import {
  useActivityLogMetricsQuery,
  useActivityLogsQuery,
} from '@common/cache';

import {
  IActivityLogsTableEntry,
  IActivityLogsTableFilters,
} from './useActivityLogsTable';
import { useState } from 'react';
import { debounce } from '@util/debounce.ts';

const initialFilter: IActivityLogsTableFilters = {
  sort_order: 'desc',
  sort_by: 'created_at',
  page: 1,
  limit: 100,
};

export const useActivityLogs = () => {
  const [filters, setFilters] = useState<IActivityLogsTableFilters>({
    ...initialFilter,
  });
  const { data, isLoading } = useActivityLogsQuery(filters);

  const onSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value;
    debounce(
      () => setFilters({ ...filters, search: newValue, page: 1 }),
      true,
      500,
    );
  };

  const metrics = useActivityLogMetricsQuery();

  const minutesToday = metrics?.data?.minutes_today || 0;
  const minutesYesterday = metrics?.data?.minutes_yesterday || 0;
  const minutesThisMonth = metrics?.data?.minutes_this_month || 0;
  const minutesLastMonth = metrics?.data?.minutes_last_month || 0;

  const entries: IActivityLogsTableEntry[] =
    data?.activities.map(activity => ({
      id: activity.id,
      title: activity.title || '-',
      created_at: activity.created_at,
      recorded_minutes: activity.recorded_minutes,
      provider_name: activity.provider_name,
      provider_practice_name: activity.provider_practice_name,
      entity_names: activity.entity_names,
      entity_types: activity.entity_types,
      timestamp: activity.timestamp,
      description: activity.description,
      editable: activity.editable,
      patient_id: activity.patient_id,
    })) ?? [];

  return {
    entries,
    count: data?.count ?? 0,
    isLoading: isLoading,
    filters,
    setFilters,
    onSearchChange,
    minutesToday,
    minutesYesterday,
    minutesThisMonth,
    minutesLastMonth,
  };
};
